"use strict";
import Login from '@/vue/apps/auth/login.vue'
import Vue from 'vue'
new Vue({
  el: '#login',
  template: '<Login ></Login>',
  components: { Login: Login },
})



// WEBPACK FOOTER //
// ./resources/wob/js/auth/login.js